export default __webpack_public_path__ + "static/media/regular-fruity.53b1f5c8.jpg";